<section class="contact-section section-padding vw-100 overflow-hidden" [ngClass]="{'pt-0': isPage}">
  <div class="container container-max">
    <div class="row g-5">
      <div class="col-lg-6">
        <span class="section-subtitle-pill bg-2">Contact</span>
        <h2 class="heading-color-1 section-title mt-2 mb-3">We are here to assist</h2>
        <p class="fs-15 mb-4">Connect with official Corporate Affairs Commission Headquarters</p>

        <ul class="list-unstyled d-flex flex-column gap-2">
          <li class="contact-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:map-pin'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-14 text-uppercase fw-semibold mb-1">Commission Headquarters</h3>
              <p class="fs-16 heading-font heading-color-1 fw-semibold line-height-150p">Plot 420, Tigris Crescent, off Aguyi Ironsi Street, Maitama, Abuja, Nigeria</p>
            </div>
          </li>
          <li class="contact-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:phone'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-14 text-uppercase fw-semibold mb-1">Corporate Help Desk</h3>
              <p class="fs-16 heading-font heading-color-1 fw-semibold line-height-150p"><a href="tel:+2347080629000">+234 708 062 9000</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="tel:+2348095554321">+234 809 555 4321</a></p>
            </div>
          </li>
          <li class="contact-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:mail'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-14 text-uppercase fw-semibold mb-1">Electronic Mail Communication</h3>
              <p class="fs-16 heading-font heading-color-1 fw-semibold line-height-150p"><a href="mailto:cservice@cac.gov.ng">{{ 'cservice@cac.gov.ng' }}</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="mailto:portal.support@cac.gov.ng">{{ 'portal.support@cac.gov.ng' }}</a></p>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-lg-6">
        @if (isSuccessful()) {
          <div class="pt-lg-5 mt-lg-5">
            <div class="card py-5 mt-lg-5">
              <div class="text-center py-3 mx-auto" style="max-width: 460px">
                <iconify [name]="'lucide:circle-check-big'" class="text-success" [size]="100" />
                <h2 class="card-title fs-20 mb-2 mt-3">Your Message Has Been Sent!</h2>
                <p class="mb-2">We are going to review your message as soon as possible. We may be in touch if we need or require any additional follow up.</p>
                <p>Thank You!</p>
              </div>
            </div>
          </div>
        } @else {
          <form [formGroup]="form" class="d-flex flex-column gap-3">
            <div class="card">
              <div class="mb-4">
                <h2 class="card-title fs-20">Send Us a Message</h2>
              </div>

              <div class="row g-3">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Full Name (Organization / Individual)</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="e.g. James Olaji or Aliyu Ibrahim & Co. Partners"
                      [formControlName]="'fullName'"
                      [ngClass]="{'error': hasFormError('fullName')}"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Your Contact Email Address</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="e.g. me@example.com"
                      [formControlName]="'email'"
                      [ngClass]="{'error': hasFormError('email')}"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label">Subject</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="e.g. I need assistance with..."
                      [formControlName]="'subject'"
                      [ngClass]="{'error': hasFormError('subject')}"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Details of Your Message</label>
                    <textarea
                      class="form-control"
                      placeholder="Write down the full details of your contact message..."
                      [formControlName]="'message'"
                      [ngClass]="{'error': hasFormError('message')}"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <button [disabled]="working()" class="btn btn-success w-100" (click)="submitContactForm()">
                    @if (working()) {
                      <loading-icon />
                    } @else {
                      <iconify [name]="'lucide:send'" />
                    }
                    Submit
                  </button>
                </div>
              </div>
            </div>

            <div class="card d-flex gap-2 text-primary py-3">
              <span class="text-danger"><iconify [size]="18" [name]="'lucide:shield-alert'" /></span>
              <span class="fs-13">Abuse or misuse of this contact form, including, but not limited to; intentional submission of false claims or spamming, is subject to administrative sanctions.</span>
            </div>


          </form>
        }
      </div>
    </div>
  </div>
</section>
